module.exports = __webpack_public_path__ + "img/icon2-2.894131e2.png";